import type { AtmospherePreset } from '../presets.config';
import { multiPlaneParallax, biomeCloser } from '../presetBuilders';
import { WICKHAVEN_SILHOUETTES } from '../../../game/effects/atmosphere/silhouettes/wickhavenSilhouettes';

/** An inhabited woodland harbor: blue-green distance, slate roofs, amber window light. */
export const WICKHAVEN: AtmospherePreset = {
  id: 'wickhaven',
  layers: [
    { kind: 'skyGradient', from: 0x20313d, to: 0x667d79 },
    ...multiPlaneParallax([
      { shape: 'ridge', color: 0x496963, speed: 0.025, height: 200, alpha: 0.76, svg: WICKHAVEN_SILHOUETTES.far },
      { shape: 'ridge', color: 0x344f50, speed: 0.07, height: 160, alpha: 0.84, svg: WICKHAVEN_SILHOUETTES.mid },
      { shape: 'ridge', color: 0x263d42, speed: 0.12, height: 100, alpha: 0.87, svg: WICKHAVEN_SILHOUETTES.near },
    ]),
    {
      kind: 'fireflies', count: 10, colors: [0xc0b980, 0xcaa36b],
      sizeMin: 4, sizeMax: 8, driftPx: 16,
      periodMinMs: 9000, periodMaxMs: 16000, alphaMin: 0.12, alphaMax: 0.34,
    },
    ...biomeCloser({
      vignette: { color: 0x132930, edgeAlpha: 0.22, washColor: 0x344b4b, washAlpha: 0.035 },
      grade: { top: 0x8a9a8c, bottom: 0x283d42, strength: 0.06, blend: 'normal' },
    }),
  ],
};
